import { Figure, FigureCaption, NextImage } from './Figure';
Figure.displayName = "FigureBase";
NextImage.displayName = "Figure.Image";
FigureCaption.displayName = "Figure.Caption";
export { Figure as default, FigureCaption as Caption, NextImage as Image };